// extracted by mini-css-extract-plugin
module.exports = {"bg":"article-image_bg__jVcjP","innerbg":"article-image_innerbg__iayoL","inner":"article-image_inner__1OO71"};